import { canUploadImages, pickImageFiles } from '../image';
import { RTE_EXTENSIONS } from '../types/rich-text-editor';
import { Group } from './types';

export const GROUPS: Group[] = [
	{
		name: 'headings',
		title: 'Headings',
		commands: [
			{
				name: 'heading1',
				label: 'Heading 1',
				iconName: 'Heading1',
				description: 'High priority section title',
				aliases: ['h1'],
				action: (editor) => {
					editor.chain().focus().setHeading({ level: 1 }).run();
				},
			},
			{
				name: 'heading2',
				label: 'Heading 2',
				iconName: 'Heading2',
				description: 'Medium priority section title',
				aliases: ['h2'],
				action: (editor) => {
					editor.chain().focus().setHeading({ level: 2 }).run();
				},
			},
			{
				name: 'heading3',
				label: 'Heading 3',
				iconName: 'Heading3',
				description: 'Low priority section title',
				aliases: ['h3'],
				action: (editor) => {
					editor.chain().focus().setHeading({ level: 3 }).run();
				},
			},
		],
	},
	{
		name: 'lists',
		title: 'Lists',
		commands: [
			{
				name: 'bulletList',
				label: 'Bullet List',
				iconName: 'List',
				description: 'Unordered list of items',
				aliases: ['ul'],
				action: (editor) => {
					editor.chain().focus().toggleBulletList().run();
				},
			},
			{
				name: 'numberedList',
				label: 'Numbered List',
				iconName: 'ListOrdered',
				description: 'Ordered list of items',
				aliases: ['ol'],
				action: (editor) => {
					editor.chain().focus().toggleOrderedList().run();
				},
			},
		],
	},
	{
		name: 'media',
		title: 'Media',
		commands: [
			{
				name: 'image',
				label: 'Image',
				iconName: 'Image',
				description: 'Upload an image',
				aliases: ['img', 'picture', 'photo'],
				// Not just "is IMAGE loaded" — the node also loads read-only, with no way to upload.
				shouldBeHidden: (editor) => !canUploadImages(editor),
				action: (editor) => {
					void pickImageFiles().then((files) => {
						if (files.length) editor.chain().focus().insertImageFiles(files).run();
					});
				},
			},
			{
				name: 'youtube',
				label: 'YouTube',
				iconName: 'Youtube',
				description: 'Embed a YouTube video',
				aliases: ['video', 'yt', 'embed'],
				/** Hidden in editors that never loaded the extension this command drives. */
				shouldBeHidden: (editor) =>
					!editor.extensionManager.extensions.some(({ name }) => name === RTE_EXTENSIONS.YOUTUBE),
				action: (editor) => {
					editor.chain().focus().openYoutubePrompt().run();
				},
			},
		],
	},
];

export default GROUPS;
